// extracted by mini-css-extract-plugin
module.exports = {"titleSeperatorWrapper":"SectionTitleSeperator-module--titleSeperatorWrapper--1C916","verticalLine":"SectionTitleSeperator-module--verticalLine--2D2Yw"};